import env from "Consts/env";
import { handle498OnClient } from "Helpers/is498";
import { apiSlice } from "../api/apiSlice";

export const profileApiSlice = apiSlice.injectEndpoints({
	endpoints: (builder) => ({
		getBadgeCount: builder.query({
			query: () => ({
				url: "/api/fds-cart/total/badge-count",
				headers: {
					...env.HEADERS,
				},
				validateStatus: (response) => response.status === 304
					|| (response.status >= 200 && response.status < 300)
				,
			}),
			async onQueryStarted(id, { dispatch, queryFulfilled }) {

				try {

					const response = await queryFulfilled;
					if (response?.data?.meta?.code === 498) {

						dispatch(handle498OnClient(response?.data));

					}

				} catch (err) {

					dispatch(handle498OnClient(err?.error?.data));

				}

			},
			providesTags: ["Badges"],

		}),
	}),
});

export const {
	useGetBadgeCountQuery,
} = profileApiSlice;
